import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Our Process', path: '/build-on-your-lot' },
      { name: 'Portfolio', path: '/portfolio' },
      { name: 'Warranty', path: '/warranty' },
      { name: 'Contact', path: '/contact' }
    ],
    services: [
      { name: 'Build on Your Lot', path: '/build-on-your-lot' },
      { name: 'Floor Plans', path: '/floor-plans' },
      { name: 'Investor Builds', path: '/investor-builds' },
      { name: 'Cost Estimate', path: '/cost-estimate' }
    ]
  };

  return (
    <footer className="bg-[#262626] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src={companyInfo.logoUrl}
              alt="EC Home Builds"
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Building custom homes with craftsmanship, transparency, and modern design in Central Ohio.
            </p>
            <div className="flex items-center space-x-2 text-[#DAA520] text-sm font-medium">
              <span>{companyInfo.yearsExperience} Years of Excellence</span>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#DAA520]">Company</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-[#DAA520] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#DAA520]">Services</h3>
            <ul className="space-y-2">
              {footerLinks.services.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-[#DAA520] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#DAA520]">Get in Touch</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#DAA520] mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">{companyInfo.location}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#DAA520] flex-shrink-0" />
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="text-gray-300 hover:text-[#DAA520] transition-colors text-sm"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#DAA520] flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-gray-300 hover:text-[#DAA520] transition-colors text-sm break-all"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm">
              Experience. Quality. Transparency.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
